export { NotMobile, OnlyMobile, NotMobileFragment, OnlyMobileFragment } from './DeviceDetect'
export { useIsMobile } from './DeviceDetect'
export { isMobile, isSafari } from 'react-device-detect'
